import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { AssignedAudioFileSpeaker } from '../types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface AssignAudioSpeakerParams {
  audioFileSpeakerId: string;
  speakerId?: string;
  name?: string;
}

export const useAssignAudioSpeaker = (matterId: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const assignSpeaker = async (params: AssignAudioSpeakerParams): Promise<AssignedAudioFileSpeaker> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: params.speakerId ? { speakerId: params.speakerId } : { name: params.name },
    });

    const response = await fetch(
      `${APIBaseChronos}/api/matters/${matterId}/audio/file-speakers/${params.audioFileSpeakerId}`,
      fetchConfig,
    );
    if (!response.ok) throw new Error('Assigning speaker failed');
    return response.json();
  };

  return useMutation({
    mutationFn: assignSpeaker,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries([QueryEntity.AudioSpeakerFiles]),
        queryClient.invalidateQueries([QueryEntity.MatterAudioSpeakers]),
        queryClient.invalidateQueries([QueryEntity.DocumentAudioBlocks]),
      ]);
    },
    onError: () => {
      toast.error('Failed to assign speaker');
    },
  });
};
